module.exports = __webpack_public_path__ + "media/images/flags/SK-17b890632e7381c0e5fd45cb3f97c4c1.svg";